var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mb-0 mt-2"},[_vm._v("Inscribirse")]),_c('sign-up1-form',{attrs:{"formType":"jwt"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }